import React, { SFC } from 'react'

import { LookupItem } from '../../../core'
import { isPresent } from '../../../shared'

type Props = {
  allValues: LookupItem[]
  valueId: number
  projectFn(item: LookupItem): string
}

const DisplayLookup: SFC<Props> = ({ valueId, allValues, projectFn }) => {
  const found = allValues.find((lookupItem) => lookupItem.id === valueId)

  return isPresent(found) ? <>{projectFn(found)}</> : null
}

export { DisplayLookup }



// WEBPACK FOOTER //
// ./src/app/shared/components/display-lookup/display-lookup.tsx